// extracted by mini-css-extract-plugin
export default {"section":"Brand_section__k3EMd","brandList":"Brand_brandList__U+bjT"};